import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { fetchDnALoadDate } from 'legacy/lut/components/widgets/public/partner360/composedReport/api/fetchDnALoadDate'
import { fetchPartnersFromGeneratedReport } from 'legacy/lut/components/widgets/public/partner360/composedReport/api/fetchPartnersFromGeneratedReport'
import { IComposedFilterForReport } from 'legacy/lut/features/partner360/composedReport'

export const createRequestsForOnFilter = (
  dataForProcedures: IComposedFilterForReport & { Guid: string },
  notFetchPartnersInScope: boolean,
  fYear: number
): [Promise<IWWPartners[] | undefined>, Promise<string | null>] => {
  if (notFetchPartnersInScope) {
    return [Promise.resolve(undefined), fetchDnALoadDate(fYear)]
  }

  return [fetchPartnersFromGeneratedReport(dataForProcedures), fetchDnALoadDate(fYear)]
}
